module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输入搜索关键词",
      "input-align": "center"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }), _vm._v(" "), _c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, _vm._l((_vm.recommendList), function(item, i) {
    return _c('van-swipe-item', {
      key: i
    }, [_c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CourseDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'CourseDetail',query:{id:item.id}}"
      }],
      staticStyle: {
        "width": "7.1rem",
        "border-radius": "5px"
      },
      attrs: {
        "src": item.pic_url,
        "alt": "",
        "srcset": ""
      }
    })])
  }), 1), _vm._v(" "), _c('van-tabs', {
    staticClass: "active-tab",
    attrs: {
      "animated": "",
      "sticky": "",
      "title-active-color": "#00B388"
    },
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('div', {
      staticClass: "course-box"
    }, _vm._l((_vm.courseList), function(item, i) {
      return _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'CourseDetail',
            query: {
              id: item.id
            }
          }),
          expression: "{name:'CourseDetail',query:{id:item.id}}"
        }],
        key: i,
        staticClass: "course-items"
      }, [_c('div', {
        staticClass: "course-pic-box"
      }, [_c('img', {
        attrs: {
          "width": "100%",
          "src": item.pic_url,
          "alt": ""
        }
      }), _vm._v(" "), (item.level) ? _c('span', [_vm._v(_vm._s(item.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "course-title on-show-one"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "course-price-box"
      }, [(item.price > 0) ? _c('span', {
        staticClass: "course-price"
      }, [_vm._v("¥" + _vm._s(item.price))]) : _vm._e(), (item.video_count > 0) ? _c('span', {
        staticClass: "course-num"
      }, [_vm._v(_vm._s(item.video_count) + "视频")]) : _vm._e()])])
    }), 0)])
  }), 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27881131","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/course/CourseIndex.vue
// module id = 1174
// module chunks = 0